import React, { useEffect } from 'react';

import { Web, Home } from '@mui/icons-material';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { getClientAccess } from './operations';
import { SubHeader, Footer, CommonTable as DQTable } from '../../components';
import './styles.scoped.css';

const ClientAccess = () => {
  const navigation = useNavigate();
  const { listData } = useSelector(state => state.clientAccess);

  useEffect(() => {
    getClientAccess();
  }, []);

  const appAccess = user => {
    navigation(`/edit-access/${user.type}/${user.id}`);
  };

  return (
    <>
      <SubHeader
        buttons={[
          { icon: <Web sx={{ color: '#fff', fontSize: 30 }} />, onPress: () => navigation('/dashboard') },
          { icon: <Home sx={{ color: '#fff', fontSize: 30 }} />, onPress: () => navigation(-1) },
        ]}
        text="Admin Portal"
      />
      <div className="wrap">
        <DQTable
          data={listData.filter(item => item.type === 'Client')}
          dataType="Client"
          handleSetData={getClientAccess}
          handleViewApps={appAccess}
          addUser={() => navigation('/client-users/add')}
          updateClientUser={() => navigation('/client-users/update')}
          showInviteButton
        />
      </div>
      <Footer />
    </>
  );
};

export default ClientAccess;
